/**
 * @generated SignedSource<<ba6b496c71258fc847e3ec3f3091dba3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type identityprovidertype = "AXON" | "OIDC" | "SAML" | "UNKNOWN" | "%future added value";
export type updateSamlIdentityProviderMutation$variables = {
  metadataFile?: string | null;
  metadataUrl?: string | null;
  name?: string | null;
  nodeId: string;
};
export type updateSamlIdentityProviderMutation$data = {
  readonly updateSamlIdentityProvider: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly identityProviderConfiguration: {
      readonly id: string;
      readonly name: string;
      readonly providerType: identityprovidertype;
      readonly samlAcsUrl: string | null;
      readonly samlMetadataUrl: string | null;
      readonly uuid: string;
    } | null;
  } | null;
};
export type updateSamlIdentityProviderMutation = {
  response: updateSamlIdentityProviderMutation$data;
  variables: updateSamlIdentityProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataFile"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metadataUrl"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "metadataFile",
        "variableName": "metadataFile"
      },
      {
        "kind": "Variable",
        "name": "metadataUrl",
        "variableName": "metadataUrl"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "nodeId",
        "variableName": "nodeId"
      }
    ],
    "concreteType": "UpdateSamlIdentityProvider",
    "kind": "LinkedField",
    "name": "updateSamlIdentityProvider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "IdentityProviderConfiguration",
        "kind": "LinkedField",
        "name": "identityProviderConfiguration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "providerType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "samlAcsUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "samlMetadataUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "updateSamlIdentityProviderMutation",
    "selections": (v4/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "updateSamlIdentityProviderMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "10b2141a3cad75f080a0b69079e590c4",
    "id": null,
    "metadata": {},
    "name": "updateSamlIdentityProviderMutation",
    "operationKind": "mutation",
    "text": "mutation updateSamlIdentityProviderMutation(\n  $nodeId: ID!\n  $name: String\n  $metadataUrl: String\n  $metadataFile: String\n) {\n  updateSamlIdentityProvider(nodeId: $nodeId, name: $name, metadataUrl: $metadataUrl, metadataFile: $metadataFile) {\n    identityProviderConfiguration {\n      id\n      uuid\n      name\n      providerType\n      samlAcsUrl\n      samlMetadataUrl\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ac14fe8c78c7119538f3eda5321fca9";

export default node;
